import Model from "./base/model";

class Transporter extends Model{
  resourceName() {
    return "transporters";
  }

  fields() {
    return {
      social_reason: "",
      fantasy_name:"",
      cnpj: "",
      municipal_registration: "",
      state_registration: "",
      telephone: "",
      type: "",
      two_factor_authentication: "",
      sector_id: "",
      responsible: { jsonApi: "hasOne", type: "users"},
      address: { jsonApi: "hasOne", type: "adresses" },
      documents: {jsonApi: "hasMany", type: "transporter_documents"},
      chat_room_id: "",
      finance_manager_id: "",
      recaptcha: "",
      unread_messages_count: "",
      extra_info: "",
      additional_data: { jsonApi: "hasOne", type: "taker_additional_data" },
      bank_accounts: { jsonApi: "hasMany", type: "bank_accounts" },
      missing_documents: "",
      taker_final_beneficiaries: {jsonApi: "hasMany", type: "taker_final_beneficiaries"},
      extra_address: {jsonApi: "hasOne", type: "addresses"},
      parent_id: "",
      avatar_path: "",
      prospector: { jsonApi: "hasMany", type: "users"},
      code : "",
      is_subsidiary: "",
      parent: { jsonApi: "hasOne", type: "transporters" },
      subsidiaries: { jsonApi: "hasMany", type: "transporters" },
      configurations: { jsonApi: "hasOne", type: "transporter_configurations"},
      notfis_email: "",
      ocoren_email: "",
      notfis_version: "",
      ocoren_version: "",
      tde: { jsonApi: "hasMany", type: "transporter_tde" },
      trt: { jsonApi: "hasMany", type: "transporter_trt" },
      risk_managers: { jsonApi: "hasMany", type: "risk_managers"},
      receive_notification: "",
      transporter_cte_reading_emails: { jsonApi: "hasMany", type: "transporter_cte_reading_emails" },
      is_onboarding: "",
      onboarding: "",
      shippers: { jsonApi: "hasMany", type: "shippers"},
    };
  }

  async setMentor(takerId, data) {
    return this.request(
      this.resourceName() + "/mentor/" + takerId,
      "POST",
      {},
      data,
    )
  }

  async setProspector(takerId, data) {
    return this.request(
      this.resourceName() + "/prospector/" + takerId,
      "POST",
      {},
      data,
    )
  }

  async search(data) {
    return this.request(
      this.resourceName() + "/search",
      "POST",
      {include:"address"},
      data
    );
  }

  async createFinance(data) {
    return this.request(
      this.resourceName() + "_finance",
      "POST",
      {},
      data
    );
  }

}

export default new Transporter();
